import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync, fetchByFilterAsync, selectDespachantes, selectStatus } from '../../features/despachante/despachanteSlice';
import { ALTERNATIVE_LOADING_STATUS, LOADING_STATUS } from '../../features/status';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectDespachanteAutocomplete({
  label,
  name,
  initialValues,
  clienteId = null,
  useFirstAsDefault = false,
  ...restProps
}) {
  const form = useForm();

  const dispatch = useDispatch();
  const list = useSelector(selectDespachantes);
  const status = useSelector(selectStatus);

  const isLoading = status === LOADING_STATUS || status === ALTERNATIVE_LOADING_STATUS;

  useEffect(() => {
    if (clienteId && clienteId > 0) {
      dispatch(fetchByFilterAsync([{ "name": "clientId", "value": clienteId }]));
    } else {
      dispatch(fetchAllAsync());
    }
  }, [clienteId]);

  const [defaultValue, setDefaultValue] = useState('');
  useEffect(() => {
    const value = list.find((item) => item.id === _.get(initialValues, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }

    if (useFirstAsDefault && (list ?? []).length > 0) {
      form.change(name, list[0].id);
    }
  }, [list, initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (option) => `${option.id} - ${option.nome}`,
  });
  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.id && item?.nome ? `${item?.id} - ${item?.nome}` : '')}
      {...restProps}
      disabled={restProps?.disabled || isLoading}
    />
  );
}
